import { render } from "./premises.vue?vue&type=template&id=7aec359f&ts=true"
import script from "./premises.vue?vue&type=script&lang=ts"
export * from "./premises.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__